/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { UpdateScheduledDateComponent } from 'app/modules/jobs/job-details/edit-job-schedule/edit-job-schedule.component';
import * as moment from 'moment';
import { DispatchBoardService } from '../dispatch-board/dispatch-board.service';
import _ from 'lodash';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { Subscription } from 'rxjs';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { debounceTime, pairwise } from 'rxjs/operators';
import { MetaData } from 'ng-event-bus/lib/meta-data';
import { Moment } from 'moment';
import { ActivatedRoute } from '@angular/router';
import { ZuperSdkEventService } from 'app/core/services/sdk_service/sdk-event.service';

@Component({
  selector: 'app-reschedule-job',
  templateUrl: './reschedule-job.component.html',
  styleUrls: ['./reschedule-job.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RescheduleJobComponent implements OnInit, OnDestroy {

  rescheduleJobForm: UntypedFormGroup;
  jobDetails: any;
  userDetails: any;
  customUserDetails: any;
  teamUid: any;
  dropDateTime: any;
  timeOffUsers: any[];
  jobOverlapUsers: any[];
  timeFormat: string;
  dateFormat: string = 'DD/MM/YYYY';
  holidayName: string;
  holidayDate: string;
  dueDate: any;
  type: 'SCHEDULE' | 'RESCHEDULE';
  routeJobAssignmentType: 'RESCHEUDLE' | 'REASSIGN' = 'RESCHEUDLE';
  dialogTitle: any;
  showWarnings: boolean = false;
  warningsList: any;
  validatingOverlapsAndTimeoff: boolean = false;
  unAssignUser: boolean = false;
  unAssignUserUid: any = null;
  unAssignUserTeamUid: any = null;
  startDateSubscription: Subscription;
  startTimePickerSubscription: Subscription;
  endTimePickerSubscription: Subscription;
  blockJobsOnHoliday: boolean = false;
  blockHolidayName: string;
  routeDetails: any;
  droppedRouteDetails: any;
  disableUpdateBtn: boolean = false;
  checkRouteJobConflict: boolean =  false;
  checkRouteDurationExceed: boolean = false;
  jobAlreadyInAnotherRoute = {show: false, msg: '', routeDetails: null};
  showClearScheduleAlert: boolean = false;
  enableClearSchedule: boolean = false;
  isHoliday: boolean;
  getWarningMsg = _.debounce((): void => {
    const [startDateTime, endDateTime] = this.getStartAndEndTime();
    this.warningsList = this._dispatchBoardService.getScheduleWarningMsg('job', this.jobDetails, this.userDetails, startDateTime, endDateTime, this.customUserDetails, false, false, { routeDetails: this.droppedRouteDetails, checkRouteJobConflict: this.checkRouteJobConflict, checkRouteDurationExceed: this.checkRouteDurationExceed });
    [this.isHoliday, this.blockHolidayName, this.blockJobsOnHoliday] = this._dispatchBoardService.isConflictWithHolidays(startDateTime, endDateTime);
    this.disableUpdateBtn = this.blockJobsOnHoliday || this.warningsList?.routeDurationExceedWarning?.show;
  }, 350, {leading: true, trailing: true});
  dateValidationRanges = {
    'minStartDate': null,
    'maxStartDate': null,
    'minEndDate': null,
    'maxEndDate': null
  };
  controlNameMappingForSDK = {
    'start_date': 'startDate',
    'end_date': 'endDate'
  };
  currentPage: string | null;
  SDKSubs$: Subscription[];

  constructor(
    private _localisationService: LocalisationService,
    public dialogRef: MatDialogRef<UpdateScheduledDateComponent>,
    public _utilityService: UtilityService,
    private formBuilder: UntypedFormBuilder,
    private _dispatchBoardService: DispatchBoardService,
    private _dataCollectorService: DataCollectorService,
    private _zuperDialogService: ZuperDialogService,
    private changeDetectorRef: ChangeDetectorRef,
    private _route: ActivatedRoute,
    private _zuperSdkEventService: ZuperSdkEventService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {}

  ngOnInit(): void {
    const browserTimezone: string = moment.tz.guess();
    this._localisationService.setDefaultLanguage();
    this.dateFormat = this._utilityService.dateFormat;
    this.timeFormat = this._utilityService.timeFormat;
    this.jobDetails = this.dialogData.data?.jobDetails;
    this.userDetails = this.dialogData.data?.userDetails;
    this.teamUid = this.dialogData.data?.teamUid;
    this.customUserDetails = this.dialogData.data?.customUserDetails;
    this.unAssignUser = this.dialogData.data?.unAssignUser ?? false;
    this.unAssignUserUid = this.dialogData.data?.unAssignUserUid || null;
    this.unAssignUserTeamUid = this.dialogData.data?.unAssignUserTeamUid || null;
    this.dropDateTime = moment.utc(this.dialogData.data?.dropDateTime).tz(browserTimezone);
    this.routeDetails = this.dialogData.data?.routeDetails || null;
    this.droppedRouteDetails = this.dialogData.data?.targetRouteDetails || null;
    this.checkRouteJobConflict =  this.dialogData.data?.checkRouteJobConflict ?? false;
    this.checkRouteDurationExceed = this.dialogData.data?.checkRouteDurationExceed ?? false;;
    this.enableClearSchedule = this.dialogData.data?.enableClearSchedule ?? false;
    this.currentPage = this._utilityService.collectRouteData(this._route.snapshot)['page'];
    this.initiateRescheduleJobForm();
    this.initiateHandlersForSDK();
  }

  ngOnDestroy(): void {
    this.startDateSubscription.unsubscribe();
    this.startTimePickerSubscription.unsubscribe();
    this.endTimePickerSubscription.unsubscribe();
    if (this.SDKSubs$) {
      this.SDKSubs$.forEach((sub$: Subscription) => sub$.unsubscribe());
      this._utilityService.castModalEventToSdk('close', {
        id: 'job_reschedule',
      });
    }
  }

  initiateRescheduleJobForm(): void {
    const scheduledStartTime = this.jobDetails?.scheduled_start_time;
    const scheduledEndTime = this.jobDetails?.scheduled_end_time;
    this.type = this._utilityService.isEmptyOrUndefined(scheduledStartTime) ? 'SCHEDULE' : 'RESCHEDULE';
    this.dialogTitle = this.getDialogTitle(this.jobDetails);

    let estimatedDays: any; let estimatedHours: any; let estimatedMinutes: any;
    if (this.type === 'SCHEDULE') {
      estimatedDays = this.jobDetails?.job_category?.estimated_duration?.days ?? 0;
      estimatedHours = this.jobDetails?.job_category?.estimated_duration?.hours ?? 0;
      estimatedMinutes = this.jobDetails?.job_category?.estimated_duration?.minutes ?? 0;
      estimatedMinutes = estimatedDays === 0 && estimatedHours === 0 && estimatedMinutes === 0 ? 60 : estimatedMinutes;
    }
    else {
      estimatedDays = 0;
      estimatedHours = 0;
      estimatedMinutes = moment(scheduledEndTime).diff(scheduledStartTime, 'minutes');
    }

    let endTimePrefill = this.dropDateTime.clone().add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
    if (this.dropDateTime.isSame(endTimePrefill)) {
      estimatedHours = 1;
      endTimePrefill = endTimePrefill.add(estimatedHours, 'hour');
    }
    const endDatePrefill = endTimePrefill;

    this.rescheduleJobForm = this.formBuilder.group({
      startDate: [this.dropDateTime, Validators.required],
      startTime: [this.dropDateTime.format(this.timeFormat), Validators.required],
      startTimePicker: [this.dropDateTime],
      endDate: [endDatePrefill, Validators.required],
      endTime: [endTimePrefill.format(this.timeFormat), [Validators.required, , endTimeMinValidator()]],
      endTimePicker: [endTimePrefill],
      reason: [''],
    });

    this.startDateSubscription = this.rescheduleJobForm.controls.startDate.valueChanges
      .subscribe((startDate: any) => {
      this.dateValidationRanges.minEndDate = startDate;
      const startTime = this.rescheduleJobForm.controls.startTimePicker.value;
      const startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
      const endDateTime = startDateTime.add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
      if (!this.rescheduleJobForm.controls.endDate.dirty) {
        this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
      }
    });

    this.startTimePickerSubscription = this.rescheduleJobForm.controls.startTimePicker.valueChanges
      .subscribe((startTime: any) => {
      this.rescheduleJobForm.controls.startTime.setValue(startTime.format(this.timeFormat));
      const startDate = this.rescheduleJobForm.controls.startDate.value;
      const startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
      this.rescheduleJobForm.controls.startDate.setValue(startDateTime);
      const endDateTime = startDateTime.clone().add(estimatedDays, 'day').add(estimatedHours, 'hour').add(estimatedMinutes, 'minute');
      if (!this.rescheduleJobForm.controls.endDate.dirty) {
        this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
      }
      this.rescheduleJobForm.controls.endTimePicker.setValue(endDateTime);
    });

    this.endTimePickerSubscription = this.rescheduleJobForm.controls.endTimePicker.valueChanges
      .subscribe((endTime: any) => {
        this.rescheduleJobForm.controls.endTime.setValue(endTime.format(this.timeFormat));
        const endDate = this.rescheduleJobForm.controls.endDate.value;
        const endDateTime = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
        this.rescheduleJobForm.controls.endDate.setValue(endDateTime);
        this.getWarningMsg();
      });
    this.jobAlreadyInAnotherRoute = {show: false, msg: '', routeDetails: null};
    if(this.checkRouteJobConflict && this.jobDetails?.route?.route_uid) {
      const isJobAlreadyInAnotherRoute = this.jobDetails?.route?.route_uid !== this.droppedRouteDetails?.route_uid;
      if(isJobAlreadyInAnotherRoute) {
        this.jobAlreadyInAnotherRoute.routeDetails = this.jobDetails?.route;
        this.jobAlreadyInAnotherRoute.show = true;
        this.jobAlreadyInAnotherRoute.msg = this._utilityService.getLocaleValue('dispatchBoard.scheduler.reschedule.warnings.remove_from_another_route') + ` '${this.jobDetails?.route?.route_name}'`;
      }
    }
    this.getWarningMsg();
  }

  isMeridian(): boolean {
    return this.timeFormat === 'hh:mm A';
  };

  getStartAndEndTime(applyTimezone: boolean = false): any[] {
    const startDate = this.rescheduleJobForm.controls.startDate.value;
    const startTime = this.rescheduleJobForm.controls.startTimePicker.value;
    const endDate = this.rescheduleJobForm.controls.endDate.value;
    const endTime = this.rescheduleJobForm.controls.endTimePicker.value;

    let startDateTime: any;
    let endDateTime: any;

    if (applyTimezone) {
      startDateTime = moment.tz(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
      endDateTime = moment.tz(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss', this._dispatchBoardService.selectedTimezone[this._dispatchBoardService.activeDispatchTab]);
    }
    else {
      startDateTime = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
      endDateTime = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    }
    return [startDateTime, endDateTime];
  }

  getDialogTitle(jobDetails: any): string {
    const workOrderNumber = jobDetails?.work_order_number || '';
    const prefix = jobDetails?.prefix || '';
    const jobTitle = jobDetails?.job_title || '';
    return `${this.type === 'RESCHEDULE' ? this._utilityService.getLocaleValue('text.reschedule', 'Reschedule') : this._utilityService.getLocaleValue('text.schedule', 'Schedule')}
    ${workOrderNumber !== '' ? '#' : ''}${prefix} ${workOrderNumber} ${jobTitle}`;
  }

  onDateChange(): void {
    this.getWarningMsg();
    this.rescheduleJobForm.get('endTime').markAsTouched();
    this.rescheduleJobForm.get('endTime').updateValueAndValidity();
  }

  rescheduleJob(): void {
    this.rescheduleJobForm.markAllAsTouched();
    if (!this.rescheduleJobForm.invalid) {
      const [startDateTime, endDateTime] = this.getStartAndEndTime(true);
      const scheduledStartTime = startDateTime.clone().utc().format('YYYY-MM-DD HH:mm:ss');
      const scheduledEndTime = endDateTime.clone().utc().format('YYYY-MM-DD HH:mm:ss');
      const reason = this.rescheduleJobForm.controls.reason.value;
      const jobUid = this.jobDetails?.job_uid;
      const userUid = this.userDetails?.user_uid;
      const teamUid = this.teamUid;
      const assignUser = this.jobDetails?.assigned_to.filter((assignee: any) => assignee.user.user_uid === userUid).length === 0;
      let isJobDropedOnDiffRoute: boolean = false;
      let oldRouteUid: any;
      let newRouteUid: any;
      if(this.routeDetails && this.droppedRouteDetails) {
        oldRouteUid = this.routeDetails?.route_uid;
        newRouteUid = this.droppedRouteDetails?.route_uid;
        isJobDropedOnDiffRoute = oldRouteUid !== newRouteUid || this.jobAlreadyInAnotherRoute.show;
      }
      if(this.jobAlreadyInAnotherRoute.show) {
        oldRouteUid = this.jobAlreadyInAnotherRoute.routeDetails?.route_uid;
      }
      const _callbackDialogData = {
        jobUid: jobUid,
        userUid: userUid,
        teamUid: teamUid,
        scheduledStartTime: startDateTime,
        scheduledEndTime: endDateTime,
        skipAssignJobToRoute: this.jobAlreadyInAnotherRoute.show
      };
      let confirmationDialogInstance: any;

      //Check for job overlaps
      const assignedTo: any[] = this.jobDetails?.assigned_to?.map((assignee: any) => _.get(assignee, ['user', 'user_uid']));
      assignedTo.push(userUid);
      this.validatingOverlapsAndTimeoff = true;
      const jobScheduleOverlapPayload = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        from_date: scheduledStartTime, to_date: scheduledEndTime, job_uid: jobUid, user_uid: assignedTo.join(',')
      };
      this._dataCollectorService.putData(this._dispatchBoardService.scheduleOverlapUrl, jobScheduleOverlapPayload)
        .subscribe(async (response: any) => {
          const customUserDetails = this._dispatchBoardService.getCustomEmployeeDetailsRemote(response?.data);
          const warnings = this._dispatchBoardService.getScheduleWarningMsg('job', this.jobDetails, this.userDetails, startDateTime, endDateTime, customUserDetails, false, true);
          const openConfirmationDialog = Object.values(warnings).filter((warning: any) => warning.show).length > 0;

          if (openConfirmationDialog) {
            confirmationDialogInstance = this._dispatchBoardService.scheduleConfirmationDialog('job',this.jobDetails, warnings);
            this.validatingOverlapsAndTimeoff = false;
            confirmationDialogInstance?.afterClosed()
              .subscribe(async (result: boolean) => {
                if (result) {
                  this.validatingOverlapsAndTimeoff = true;
                  if(isJobDropedOnDiffRoute) {
                    await this.reassignRouteJobToAnotherRoute(oldRouteUid, newRouteUid, jobUid);
                  }
                  if(!this.jobAlreadyInAnotherRoute.show) {
                    this._dispatchBoardService.scheduleAndAssignJob(jobUid, scheduledStartTime, scheduledEndTime, this.type, reason, assignUser, userUid, teamUid, this.unAssignUser, this.unAssignUserUid, this.unAssignUserTeamUid, (status: boolean) => {
                      if (status) {
                        this.dialogRef.close(_callbackDialogData);
                        this.validatingOverlapsAndTimeoff = false;
                      }
                      else {
                        this.validatingOverlapsAndTimeoff = false;
                      }
                    });
                  }
                  else {
                    this.dialogRef.close(_callbackDialogData);
                    this.validatingOverlapsAndTimeoff = false;
                  }
                }
              });
          }
          else {
            if(isJobDropedOnDiffRoute) {
              await this.reassignRouteJobToAnotherRoute(oldRouteUid, newRouteUid, jobUid);
            }
            if (!this.jobAlreadyInAnotherRoute.show) {
              this._dispatchBoardService.scheduleAndAssignJob(jobUid, scheduledStartTime, scheduledEndTime, this.type, reason, assignUser, userUid, teamUid, this.unAssignUser, this.unAssignUserUid, this.unAssignUserTeamUid, (status: boolean) => {
                if (status) {
                  this.dialogRef.close(_callbackDialogData);
                  this.validatingOverlapsAndTimeoff = false;
                }
                else {
                  this.validatingOverlapsAndTimeoff = false;
                }
              });
            }
            else {
              this.dialogRef.close(_callbackDialogData);
              this.validatingOverlapsAndTimeoff = false;
            }
          }
          this.changeDetectorRef.markForCheck();
        }, () => {
          this.validatingOverlapsAndTimeoff = false;
      });
    }
  }

  reassignRouteJobToAnotherRoute(oldRouteUid: string, newRouteUid: string, jobUid: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const param = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'assign_route_users': true, 'job_uid': jobUid, 'route_uid': newRouteUid
      };
      this._dispatchBoardService.reassignJobToAnotherRoute(oldRouteUid, param, false, (status: boolean) => {
        if (status) {
          resolve(true);
        }
        else {
          resolve(false);
        }
        this.changeDetectorRef.markForCheck();
      });
    });
  }

  getMessageWithNote(): string {
    const baseMessage = this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.message');
    if (this.jobDetails?.route) {
      return `${baseMessage} ?<br><p class="font-medium text-base mt-2 text-red-600">${this._utilityService.getLocaleValue('dispatchBoard.scheduler.dialog.clear_schedule.note')} '${this.jobDetails?.route?.route_name}'</p>`;
    }
    return `${baseMessage} ?`;
  }

  clearSchedule(): void{
    if(!this.jobDetails?.due_date) {
      this.showClearScheduleAlert = true;
      return;
    }
    const updateJobScheduleConfirmationDialog = this._zuperDialogService.open({
      title: this._utilityService.getLocaleValue('text.clear_schedule'),
      type: 'error',
      message: this.getMessageWithNote(),
      actions: {
          confirm: {
              show: true,
              label: 'Clear Schedule',
              color: 'primary',
              confirmDisplayKey: 'text.clear_schedule'
          },
          cancel: {
              show: true,
              label: 'Cancel',
              cancelDisplayKey: 'cancel.text'
          }
      }
    });
    updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
      if (result) {
        if(this.jobDetails?.route?.route_uid) {
          const removeJobParam = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            jobs: [{ job_uid: this.jobDetails?.job_uid }], unassign_users: false
          };
          const routeUid = this.jobDetails?.route?.route_uid;

          this._dataCollectorService.deleteDataPayload(`${this._dataCollectorService.baseurl()}/routes/${routeUid}/job`, removeJobParam)
          .subscribe((response: any) => {
              this.clearScheduleJob();
              this.changeDetectorRef.markForCheck();
          }, (error: any) => {
          });
        }
        else{
          this.clearScheduleJob();
          this.changeDetectorRef.markForCheck();
        }
      }
    });
  }

  clearScheduleJob(): void{
    const payload: any = {
      job: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        job_uid: this.jobDetails?.job_uid,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        due_date: moment(this.jobDetails?.due_date)?.endOf('day')?.utc()?.format('YYYY-MM-DD HH:mm:ss'),

      }
    };
    if(this.jobDetails?.job_timezone && this._utilityService.isTimeZoneEnabled === false){
      payload.job['job_timezone'] = null;
    }
    this._dataCollectorService.putData(`${this._dispatchBoardService?.jobDetailsUrl}?clear_schedule=true?`,payload).subscribe((resposne: any)=>{
      this.dialogRef.close({type: 'clearSchedule'});
      this.changeDetectorRef.markForCheck();
    },(error: any)=>{
    });
  }

  //#region UI SDK

  initiateHandlersForSDK(): void{
    this._utilityService.castModalEventToSdk('open', {
      id: 'job_reschedule',
      job_details: this.jobDetails,
    });
    const formValueChangeForSDKEmit$ = this.rescheduleJobForm.valueChanges.pipe(debounceTime(1000), pairwise()).subscribe(([prev, next]: any[]) => {
      if (this.rescheduleJobForm.valid) {
        this._utilityService.castModalEventToSdk('change', {
          id: 'job_reschedule',
          old_value: this._utilityService.convertMomentFieldsToDate(prev),
          new_value: this._utilityService.convertMomentFieldsToDate(next),
        });
      }
    });
    const formPatchSub$ = this._utilityService.listenForFormPatchEvent(`${this.currentPage}.job_reschedule`).pipe().subscribe((res: MetaData) => {
      const controlName = this.controlNameMappingForSDK[res.data['controlName']];
      const control = this.rescheduleJobForm.controls[controlName];
      if(!control){
        return;
      }
      if (res.key.includes('prop')) {
        // patching configs of form control
        if (controlName && res.data['config'] && control) {
          const validations = res.data['config'];
          let pairKey = '';
          Object.keys(validations).forEach(((key: any) => {
            switch (key) {
              case 'min':
                pairKey = controlName === 'startDate' ? 'minStartDate' : 'minEndDate';
                this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                if (control.value < this.dateValidationRanges[pairKey]) {
                  control.setValue(this.dateValidationRanges[pairKey]);
                }
                break;
              case 'max':
                pairKey = controlName === 'startDate' ? 'maxStartDate' : 'maxEndDate';
                this.dateValidationRanges[pairKey] = moment(validations[key]).isValid() ? moment(validations[key]) : null;
                if (control.value > this.dateValidationRanges[pairKey]) {
                  control.setValue(this.dateValidationRanges[pairKey]);
                }
                break;
              case 'disabled':
                if((validations[key] || false)){
                  control.disable();
                }
                break;
            }
          }));
        };
      } else if (res.key.includes('set')) {
        //patching values of form
        if (controlName && res.data['value'] && control) {
          if (moment(control.value).isValid()) {
            control.setValue(moment(res.data['value']).isValid() ? moment(res.data['value']) : control.value);
          } else {
            control.setValue(res.data['value']);
          }
        }
      }
    });
    this.SDKSubs$ = [formValueChangeForSDKEmit$, formPatchSub$];
  }

}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function endTimeMinValidator(checkRouteMaxDuration: boolean = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    const startTime = control.parent?.value.startTimePicker;
    const endTime = control.parent?.value.endTimePicker;
    const startDate = control.parent?.value.startDate;
    const endDate = control.parent?.value.endDate;
    const  validationResult: any = {};
    let isRouteDurationExceed =false;;

    if (!startTime || !endTime) {
      return null;
    }
    const startTimeObject = moment(startDate.format('YYYY-MM-DD') + ' ' + startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    const endTimeObject = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss');
    if(checkRouteMaxDuration) {
      isRouteDurationExceed = endTimeObject.diff(startTimeObject, 'm') > 1440;
      if(isRouteDurationExceed) {
        validationResult['routeMaxDurationError'] = true;
      }
      else {
        delete validationResult['routeMaxDurationError'];
      }
    }
    const invalidEndTime = endTimeObject.isSameOrBefore(startTimeObject);
    if(invalidEndTime) {
      validationResult['invalidEndTime'] = true;
    }
    else{
      delete validationResult['invalidEndTime'];
    }
    return invalidEndTime || isRouteDurationExceed ? validationResult : null;
  };
}
